
import { createContext, useContext, useState } from "react";
import { Link, Route, Routes } from "react-router-dom";
import styles from '../../../css/StaffMgmt.module.css';
import titleStyle from '../../../css/SectionTitle.module.css';
import { BsList } from "react-icons/bs";
import { MenuContext } from "../DashBoard";
import AddResultTemplate from "./AddResultTemplate";
import ViewResultTemplate from "./ViewResultTemplate";
// import AddResult from "../../../components/AddResult";
import { ResultContext } from "./ResultMgmt";


const ResultTemplate = ()=>{
    const {showMenu, setShowMenu} = useContext(MenuContext);
    const {title} = useContext(ResultContext)
    return (

            <div className={`${styles.baseView}`} style={{ display: 'flex', flexWrap: 'wrap' }}>
                <h1 className={`${styles.title}`}>Result</h1>
                <div className={`${styles.subView}`}>
                    <div className={titleStyle.sectionTitle}>
                        <h3 className={titleStyle.h3}>
                            {title}
                        </h3>
                        <div className={`${titleStyle.menuDiv}`}>
                            <span className={`${titleStyle.menuBtn}`} onClick={() => setShowMenu(!showMenu)}><BsList />Menu</span>
                            {showMenu &&
                                <div className={`${titleStyle.subMenu}`} >
                                    <ul>
                                        <li><Link to='add-result-template'>Add template</Link></li>
                                        <li><Link to='view-result-template'>View template</Link></li>
                                    </ul>
                                </div>
                            }
                        </div>
                    </div>
                    
                    
                    <Routes>
                        <Route element={<AddResultTemplate />} path={'/add-result-template'} />
                        <Route element={<ViewResultTemplate />} path={'/view-result-template'} />
                        <Route element={<ViewResultTemplate />} path={'/*'} />
                    </Routes>
                </div>
            </div>
    );
}
export default ResultTemplate;